import { YoutubeBroadcast, YoutubeBroadcastVideo } from '../../youtube-broadcast-types';
import { AppCardRouterTo } from '@app/components/base/app-card';

/**
 * Builds the logger stream route for a YouTube broadcast interval.
 * Same destination as {@link YoutubeBroadcastItem} click navigation.
 */
export function buildYoutubeBroadcastNavigation(
  broadcast: YoutubeBroadcast,
  stationSlug: string,
): AppCardRouterTo {
  const streamStartedAtMs = Date.parse(broadcast.streamStartedAt);
  const streamEndedAtMs = Date.parse(broadcast.streamEndedAt);

  return `/logger/s/${stationSlug}?from=${streamStartedAtMs}&to=${streamEndedAtMs}`;
}
